import React from 'react'

import { Col, Row } from '_zari/core'

import * as FormGroups from './formGroups'

const DocumentoInfoSection = ({ documentoInfo }) => {
  return (
    <Row>
      <Col md={8}>
        <FormGroups.FechaEmisionFormGroup iValue={documentoInfo.fechaEmision} />
        <FormGroups.TipoDocumentoFormGroup iValue={documentoInfo.tipoDocumento} />
        <FormGroups.NumeroSerieDocumentoFormGroup
          iNumeroValue={documentoInfo.numeroDocumento}
          iSerieValue={documentoInfo.serieDocumento}
        />
      </Col>
    </Row>
  )
}

export default React.memo(DocumentoInfoSection)
